module.exports = __webpack_public_path__ + "static/media/Paid.82a2b3ec.svg";